var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.15703 13.0867C1.19149 12.7766 1.20872 12.6215 1.25564 12.4766C1.29726 12.348 1.35607 12.2257 1.43048 12.1128C1.51434 11.9857 1.62466 11.8753 1.8453 11.6547L11.75 1.75C12.5784 0.92157 13.9216 0.921571 14.75 1.75C15.5784 2.57843 15.5784 3.92157 14.75 4.75L4.84529 14.6547C4.62466 14.8753 4.51434 14.9857 4.38717 15.0695C4.27434 15.1439 4.15197 15.2027 4.02338 15.2444C3.87845 15.2913 3.72339 15.3085 3.41328 15.343L0.875 15.625L1.15703 13.0867Z",
    stroke: "#0E5E84",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.e60ae89a5e23dcfaf155b04ad392dcd8.svg";
export { ForwardRef as ReactComponent };